var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5974",
    "data-name": "Rectangle 5974",
    width: 20,
    height: 20,
    fill: "#5e6b1e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36430",
    "data-name": "Group 36430",
    transform: "translate(-242 -10752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_666",
    "data-name": "Mask Group 666",
    transform: "translate(242 10752)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36429",
    "data-name": "Group 36429",
    transform: "translate(4.167 3.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55772",
    "data-name": "Path 55772",
    d: "M7.4,4.835h8.964a1.357,1.357,0,0,1,1.356,1.356v1.5a2.532,2.532,0,0,1-.678,1.566l-2.922,2.583a2.2,2.2,0,0,0-.678,1.566v2.922a1.524,1.524,0,0,1-.608,1.157l-.947.6a1.381,1.381,0,0,1-2.1-1.157v-3.6a2.551,2.551,0,0,0-.549-1.426L6.656,9.171a2.209,2.209,0,0,1-.608-1.356V6.261A1.373,1.373,0,0,1,7.4,4.835Z",
    transform: "translate(-6.049 -4.835)",
    fill: "none",
    stroke: "#5e6b1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.d20db28b612c0f055f6cd7f22843a7b4.svg";
export { ForwardRef as ReactComponent };